import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Text } from '../../../Elements/Elements';

import classes from './TrendView.module.scss';

const TrendView = ({ trend, isPercent = false }) => {
  if (trend === 0) {
    return '';
  }
  return (
    <Text className={classes.trend}>
      <span
        className={cn(
          classes.arrow,
          trend > 0 ? classes.arrow_up : trend < 0 ? classes.arrow_down : ''
        )}
      />
      <Text
        className={cn(
          trend > 0 ? classes.trend_up : trend < 0 ? classes.trend_down : ''
        )}
        size={2}
      >
        {trend > 0 ? trend : trend * -1}
        {isPercent ? '%' : null}
      </Text>
    </Text>
  );
};

TrendView.propTypes = {
  trend: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPercent: PropTypes.bool
};

export default TrendView;
